import React from 'react';
import { toast } from 'react-toastify';

import { formatUuid } from '../../utils/formatUuid';
import { Tooltip } from './tooltip';

interface Props {
  uuid: string | null | undefined;
  fallback?: string;
}

export const UuidDisplay: React.FC<Props> = ({ uuid, fallback = '-' }) => {
  if (!uuid) {
    return <span>{fallback}</span>;
  }

  const copy = () => {
    navigator.clipboard.writeText(uuid).then(() => {
      toast.info('Copied to clipboard');
    });
  };

  return (
    <Tooltip tooltip={uuid}>
      <span onClick={copy} style={{ cursor: 'pointer' }} aria-hidden>
        {formatUuid(uuid)} ❏
      </span>
    </Tooltip>
  );
};
